import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import tripadvisor_logo from '../../assets/images/tripadvisor_logo.png';
import viator_logo from '../../assets/images/viator_logo.png';
import expedia_logo from '../../assets/images/expediaLogo.png';
import vrbo_logo from '../../assets/images/VrboLogo.svg';
import hotels_com_logo from '../../assets/images/HotelsCom.png';
import maya_logo from '../../assets/images/maya-mobile-logo.png';
import booking_logo from '../../assets/images/bookingLogoStay.svg';

// Partners logos and links
const partners = [
    { id: 1, name: 'TripAdvisor', logo: tripadvisor_logo, link: 'https://www.tripadvisor.com' },
    { id: 2, name: 'Viator', logo: viator_logo, link: 'https://www.viator.com' },
    { id: 3, name: 'Booking', logo: booking_logo, link: 'https://www.awin1.com/awclick.php?mid=18117&id=1919965' },
    { id: 4, name: 'Expedia', logo: expedia_logo, link: 'https://expedia.com/affiliates/expedia-home.5sAwO1q' },
    { id: 5, name: 'Maya', logo: maya_logo, link: 'https://maya.net/?pid=cQ0KfzUI9LpL' },
    { id: 6, name: 'Hotels.com', logo: hotels_com_logo, link: 'https://hotels.com/affiliate/gIbAdZd' },
    { id: 7, name: 'VRBO', logo: vrbo_logo, link: 'https://vrbo.com/affiliates/vrbo-home.yvxDtMG' },

    { id: 8, name: 'TripAdvisor', logo: tripadvisor_logo, link: 'https://www.tripadvisor.com' },
    { id: 9, name: 'Viator', logo: viator_logo, link: 'https://www.viator.com' },
    { id: 10, name: 'Booking', logo: booking_logo, link: 'https://www.awin1.com/awclick.php?mid=18117&id=1919965' },
    { id: 11, name: 'Expedia', logo: expedia_logo, link: 'https://expedia.com/affiliates/expedia-home.5sAwO1q' },
    { id: 12, name: 'Maya', logo: maya_logo, link: 'https://maya.net/?pid=cQ0KfzUI9LpL' },
    { id: 13, name: 'Hotels.com', logo: hotels_com_logo, link: 'https://hotels.com/affiliate/gIbAdZd' },
    { id: 14, name: 'VRBO', logo: vrbo_logo, link: 'https://vrbo.com/affiliates/vrbo-home.yvxDtMG' },

];

// Define the keyframes for continuous scrolling
const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

// Container for the slider
const SliderContainer = styled(Box)({
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    marginTop: '2rem', // Margin between the title and images
});

// Content of the slider that loops
const SliderContent = styled(Box)({
    display: 'flex', // Change to flexbox for seamless looping
    whiteSpace: 'nowrap',
    animation: `${scroll} 14s linear infinite`, // Duration adjusted for seamless effect
    animationTimingFunction: 'linear',
    '&:hover': {
        animationPlayState: 'paused', // Pause animation on hover
    },
});

const StyledCard = styled(Box)(({ theme }) => ({
    display: 'flex', // Use flexbox for alignment
    justifyContent: 'center',
    alignItems: 'center', // Center vertically
    padding: '1%', // Padding by percentage
    height: '10vw', // Height adapted to window width to provide room for vertical centering
    userSelect: 'none', // Disable text selection
    '&:hover img': {
        transform: 'scale(1.05)', // Enlarge image by 5% on hover
    },
    img: {
        transition: 'transform 0.3s ease', // Smooth transition for hover effect
        pointerEvents: 'none', // Prevent interaction
    },
    [theme.breakpoints.down('sm')]: {
        height: '20vw', // Increase height on mobile devices
    },
}));

const PartnerImage = styled('img')(({ theme }) => ({
    height: '4vw', // Set a consistent height for all images
    width: 'auto',
    objectFit: 'contain',
    transition: 'transform 0.3s ease',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
        height: '10vw', // Increase image height on mobile devices
    },
}));

const Partners = () => {
    const theme = useTheme();

    return (
        <Container
            sx={{
                textAlign: 'center',
                padding: '2rem 0',
                userSelect: 'none', // Disable text selection for the entire container
                [theme.breakpoints.down('sm')]: {
                    padding: '4px 20px',
                    marginTop: '-10px',
                },
            }}
        >

            <Typography
                variant="h4"
                sx={{
                    fontWeight: 500,
                    color: '#dc5454',
                    fontSize: { xs: '1.2rem', sm: '2rem' },
                    mb: 2,
                }}
            >
                Our Partners
            </Typography>

            <Typography
                variant="body1"
                component="p"
                gutterBottom
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '1rem', sm: '1.15rem' },
                    // maxWidth: { xs: '100%', sm: '75%' },
                    marginBottom: '2rem',
                    userSelect: 'none',
                }}
            >
                These are the companies that complete your experience to perfection
            </Typography>

            <SliderContainer>
                <SliderContent>
                    {partners.concat(partners).map((partner, index) => ( // Duplicate list for continuous effect
                        <StyledCard key={index}>
                            <a href={partner.link} target="_blank" rel="noopener noreferrer">
                                <PartnerImage
                                    src={partner.logo}
                                    alt={partner.name}
                                    onMouseDown={(e) => e.preventDefault()} // Prevent dragging with JavaScript
                                />
                            </a>
                        </StyledCard>
                    ))}
                </SliderContent>
            </SliderContainer>
        </Container>
    );
};

export default Partners;